/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFiscalCalendar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4V2h2v2h6V2h2v2h5v18H2V4zm0 2H4v14h16V6h-3v2h-2V6H9v2H7zm4 3.167V8.5h2v.667h2v2h-2V12.5h.5c1.477 0 2.5 1.296 2.5 2.667 0 1.37-1.023 2.666-2.5 2.666H13v.667h-2v-.667H9v-2h2V14.5h-.5c-1.477 0-2.5-1.296-2.5-2.667 0-1.37 1.023-2.666 2.5-2.666zm0 2h-.5c-.18 0-.5.196-.5.666s.32.667.5.667h.5zm2 3.333v1.333h.5c.18 0 .5-.196.5-.666s-.32-.667-.5-.667z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFiscalCalendar as FiscalCalendar };
